(function (Translator) {
    // en
    Translator.add("rate_list.rate.bg_kbcbank", "KBC Bank amount", "EvpThemeBundle", "en");
    Translator.add("recaptcha.description", "This message is intended to verify whether a person is browsing and to avoid automatic checking systems", "EvpThemeBundle", "en");
    Translator.add("recaptcha.title", "Are you a robot?", "EvpThemeBundle", "en");
})(Translator);
